import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function ClockCountDownIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M21.563 12.795A9.575 9.575 0 1 1 11.205 2.439a.564.564 0 1 1 .095 1.125 8.45 8.45 0 1 0 9.139 9.141.566.566 0 0 1 1.125.095v-.005ZM11.438 6.75V12a.563.563 0 0 0 .562.563h5.25a.563.563 0 0 0 0-1.125h-4.687V6.75a.563.563 0 1 0-1.125 0ZM15 4.313a.938.938 0 1 0 0-1.875.938.938 0 0 0 0 1.875Zm3.375 2.25a.938.938 0 1 0 0-1.875.938.938 0 0 0 0 1.875Zm2.25 3.375a.938.938 0 1 0 0-1.875.938.938 0 0 0 0 1.875Z"
        fill="currentColor" />
    </BaseIcon>
  )
}
